var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftQuot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 211,
    viewBox: "0 0 280 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M128.906 0C65.7063 24 0.106323 81.6 0.106323 138.4C0.106323 165.6 18.5063 194.4 43.3063 210.4L122.506 148.8V146.4C102.506 128 81.7063 101.6 81.7063 81.6C81.7063 57.6 104.106 28 133.706 8.80003L128.906 0ZM274.506 0C211.306 24 144.906 81.6 144.906 138.4C144.906 165.6 164.106 194.4 188.906 210.4L267.306 148.8V146.4C248.106 128 226.506 101.6 226.506 81.6C226.506 57.6 249.706 28 279.306 8.80003L274.506 0Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftQuot);
export default __webpack_public_path__ + "static/media/left-quot.4a1bbfda463fed2ed73bb6edc09dc97f.svg";
export { ForwardRef as ReactComponent };